import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, AuthService, GenesisUnitOfWork, ReportService } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';
import _ from 'lodash';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-frame-overview',
    templateUrl: './frame-overview.component.html',
    styleUrls: ['./frame-overview.component.scss'],
    standalone: false
})
export class FrameOverviewComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    frames: any;
    partsWithFrame: any;

    isToastVisible = false;
    processing = false;
    showAsDialog = false;


    canSeeCost = false;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(
        private uow: GenesisUnitOfWork,
        private router: Router,
        public auth: AuthService,
        private modalService: BsModalService,
        private appInfo: AppInformationService,
        private reportService: ReportService
    ) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        const frames = await this.uow.getFrameParts() as any[];
        let i = 0
        frames.forEach(frame => {
            frame.id = i;
            let partList = [];
            if (frame.parts.length > 0 ) {
                frame.parts.forEach(part => {
                    partList.push(`New: ${part.newCount} - ${part.partNumber}`);
                });
                frame.partList = partList.join('; ')
            }
            i++;
        });
        this.frames = frames
        const partsWithFrame = await this.uow.getPartFrames() as any[];
        this.partsWithFrame = partsWithFrame;
    }

    hasChanges() {
        return this.uow.hasChanges();
    }

    async selectionChange(e) {
        // console.log(e);
    }

    async rowPrepare(e) {
    }

    async save() {

    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }



    async open(partId: number) {
        this.router.navigate(['/parts/' + (partId ? partId : 'new')]);
    }

    async rowDoubleClick(e) {
        if (!e.data || !e.data.id) return;
        await this.open(e.data.id);
    }

    // this method is used to clear the selection when the user searches for something
    onOptionChanged(e) {
        if (e.fullName === 'searchPanel.text') {
            e.component.__searchChanged = true;
        }
        const filterCheck = _.includes(e.fullName, 'filterValue');
        if (filterCheck) {
            this.dataGrid.instance.clearSelection();
        }
    }

    // this method is used to clear the selection when the user searches for something
    onContentReady(e) {
        if (e.component.__searchChanged) {
            //__searchChanged is for the search box
            e.component.__searchChanged = false;
            this.dataGrid.instance.clearSelection();
        }
    }

}
